import { Navigate, Outlet } from 'react-router-dom';

import PublicLayout from 'components/UI/PublicLayout';

import { useUserStore } from '../store/useUserStore';
import routes from '../utils/routes';

const PublicRoute = () => {
  const loginStore = useUserStore();

  const token = loginStore?.token?.accessToken;

  return !token ? (
      <PublicLayout>
        <Outlet />
      </PublicLayout>
  ) : (
    <Navigate to={routes.GAME} />
  );
};

export default PublicRoute;
